import {NgModule} from '@angular/core';
import {APP_BASE_HREF} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatSelectModule} from "@angular/material/select";
import {MatIconModule} from "@angular/material/icon";


import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';

import {AppService} from "./app.service";
import {ContentService} from "./content.service";
import {LoginComponent, LoginComponentUrlDialog} from './login/login.component';
import {ColorPickerDialog, ContentComponent, ReconnectDialog, SettingsDialog} from './content/content.component';
import {WorkerListDialog, WorkersComponent, WorkerGridFilterPipe} from './workers/workers.component';
import {TRANSLATION_PROVIDERS} from './translate/translation';
import {TranslatePipe} from './translate/translate.pipe';
import {TranslateService} from './translate/translate.service';
import {WorkerInfoComponent} from './worker-info/worker-info.component';
import {ToggleFullscreenDirective} from './toggle-fullscreen.directive';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatNativeDateModule,
        MatButtonModule,
        MatInputModule,
        MatToolbarModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        MatListModule,
        MatFormFieldModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        MatTooltipModule,
        MatSelectModule,
        MatIconModule,
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        ContentComponent,
        ReconnectDialog,
        ColorPickerDialog,
        SettingsDialog,
        WorkersComponent,
        WorkerGridFilterPipe,
        TranslatePipe,
        WorkerListDialog,
        WorkerInfoComponent,
        ToggleFullscreenDirective,
        LoginComponentUrlDialog
    ],
    bootstrap: [AppComponent],
    providers: [AppService, ContentService, TRANSLATION_PROVIDERS, TranslateService,
      { provide: APP_BASE_HREF, useValue: '/htdocs/apps/terminal' }
    ]
})
export class AppModule {
}
